export const videos = [
  {
    title: "Réinitialiser mon mot de passe",
    subtitle: "Tutoriel vidéo sur réinitialiser mon mot de passe",
    url: "https://www.loom.com/share/b4939dea6b81466abfbe72fb3e7f0111?sid=1815bb1e-6284-425f-8049-24b3cf026052",
    tab: "Paramètres",
    duration: "0:42",
  },
  {
    title: "Modifier mon numéro de sécurité",
    subtitle: "Tutoriel vidéo sur moifier mon numéro de sécurité",
    url: "https://www.loom.com/share/c06d8351660a4b6ea8dde3f934fd19f3?sid=2d3f5bc7-8d16-4427-b9b1-4c0a9cd8bd3a",
    tab: "Paramètres",
    duration: "0:48",
  },
  {
    title: "Modifier les infos de l'entreprise",
    subtitle: "Tutoriel vidéo sur modifier les infos de l'entreprise",
    url: "https://www.loom.com/share/eb45d46d3af6482f8a47885b559eaf29?sid=0d981386-bf42-4d7f-ab9c-8a0d60db0be2",
    tab: "Paramètres",
    duration: "0:41",
  },
  {
    title: "Ajouter le logo de l'entreprise",
    subtitle: "Tutoriel vidéo sur ajouter le logo de l'entreprise",
    url: "https://www.loom.com/share/abb6ea8c3ac4491d97eaab6237d295ed?sid=6829119e-74ad-4beb-b6d4-b6deef395562",
    tab: "Paramètres",
    duration: "0:21",
  },
  {
    title: "Inviter un nouveau membre",
    subtitle: "Tutoriel vidéo sur inviter un nouveau membre",
    url: "https://www.loom.com/share/22c4128d610f4dbdab9aa3bbb4043f96?sid=600a2601-7da0-4aa2-9f7b-24d857753f2f",
    tab: "Paramètres",
    duration: "1:26",
  },
  {
    title: "Modifier les alertes par emails",
    subtitle: "Tutoriel vidéo sur modifier les alertes par emails",
    url: "https://www.loom.com/share/de4a588f97bc455e84e2688bd81e6157?sid=93852111-3fe0-41a3-95ec-b8aa48ff750c",
    tab: "Paramètres",
    duration: "1:01",
  },
  {
    title: "Créer un modele d'email",
    subtitle: "Tutoriel vidéo sur créer un modele d'email",
    url: "https://www.loom.com/share/906836f5dd06418db5b92d22ce181c0d?sid=2d51907d-712f-4091-b93b-02625e7a2750",
    tab: "Paramètres",
    duration: "2:41",
  },
  {
    title: "Ajouter un tag",
    subtitle: "Tutoriel vidéo sur ajouter un tag",
    url: "https://www.loom.com/share/7deb547e6f7b40e5a44feceefb7956e3?sid=3b76deb9-8714-4a40-9747-1d91d806cd3e",
    tab: "Paramètres",
    duration: "1:55",
  },
  {
    title: "Rappels automatiques",
    subtitle: "Tutoriel vidéo sur configurer les rappels automatiques",
    url: "https://www.loom.com/share/17cb987c8c3149fabf2fbd008336c31a?sid=cd99dd74-63e6-4973-a15d-2ff297327978",
    tab: "Paramètres",
    duration: "3:23",
  },
  {
    title: "Créer une prestation",
    subtitle: "Tutoriel vidéo sur créer une prestation",
    url: "https://www.loom.com/share/02144a540e1e4bb79f389df380a56c72?sid=dcef6552-eadd-4be3-a7bd-98861e6bce28",
    tab: "Paramètres",
    duration: "3:58",
  },
  {
    title: "Validation automatique",
    subtitle: "Configurez les documents avec validation automatique",
    url: "https://www.loom.com/share/f28dce0b9a394bec932340afbb199987?sid=84005433-51be-41d7-a40a-bd4859a858ce",
    tab: "Paramètres",
    duration: "0:50",
  },
  {
    title: "Bibliothèque",
    subtitle: "Gestion de la bibliothèque de documents ",
    url: "https://www.loom.com/share/ea09d08a13184405a27449d622a66f47?sid=3f0037c0-9eea-4066-9342-189b4aa1faf1",
    tab: "Paramètres",
    duration: "0:58",
  },
  {
    title: "Configurer les informations de l'entreprise",
    subtitle: "Tutoriel vidéo sur configurer les informations de l'entreprise",
    url: "https://www.loom.com/share/16ec3002e6164917a7e4f5706d9d8699?sid=37751397-fbe6-43b6-bdac-1b03dd170fb0",
    tab: "Devis",
    duration: "1:24",
  },
  {
    title: "Créer des articles",
    subtitle: "Tutoriel vidéo sur créer des articles",
    url: "https://www.loom.com/share/87f176b4c4b145299358d3960f2456ed?sid=52d40f01-0248-4283-89f2-09989c254d79",
    tab: "Devis",
    duration: "1:35",
  },
  {
    title: "Créer un brouillon de Devis",
    subtitle: "Tutoriel vidéo sur créer un brouillon de Devis",
    url: "https://www.loom.com/share/ecdca1746dec47c0a041933ba0caafca?sid=1ae19f08-d201-4c98-abb2-ed2e45fdccf9",
    tab: "Devis",
    duration: "2:45",
  },
  {
    title: "Créer un Devis à partir du brouillon",
    subtitle: "Tutoriel vidéo sur créer un Devis à partir du brouillon",
    url: "https://www.loom.com/share/7549ffa7e2904dfabb4b920f1a768355?sid=5e3b28da-5696-4bba-ad93-b515a592abc7",
    tab: "Devis",
    duration: "1:35",
  },
  {
    title: "Envoyer le Devis à signer",
    subtitle: "Tutoriel vidéo sur envoyer le Devis à signer",
    url: "https://www.loom.com/share/01658d90b1254b5ea393294071f88998?sid=64305237-6c60-43b0-9723-7cb25298f78f",
    tab: "Devis",
    duration: "2:00",
  },
  {
    title: "Créer un dossier à partir du Devis signé",
    subtitle: "Tutoriel vidéo sur créer un dossier à partir du Devis signé",
    url: "https://www.loom.com/share/49bba28ade6247dfb098333814b980ac?sid=dbd23de2-71cb-43c3-aea4-08a9b9ba5e0b",
    tab: "Devis",
    duration: "1:03",
  },
  {
    title: "Devis signé en dehors d'hexagone",
    subtitle: "Tutoriel vidéo sur déposer un Devis signé en dehors d'hexagone",
    url: "https://www.loom.com/share/c90e51e2bcc740ceb06ff2a0c8bbd037?sid=7e882e3e-09eb-4862-ba84-4ecfc4899285",
    tab: "Devis",
    duration: "0:49",
  },
  {
    title: "Ajouter un Devis au dossier",
    subtitle:
      "Ajouter un Devis au dossier si on n'utilise pas les Devis d'hexagone",
    url: "https://www.loom.com/share/c5d04b665b0746a88094085fa7d84fd1?sid=16141f0b-4ebc-4ef4-a5e7-c4b245326773",
    tab: "Devis",
    duration: "0:46",
  },
  {
    title: "Mettre un widget sur mon site web",
    subtitle: "Tutoriel vidéo sur mettre un widget sur mon site web",
    url: "https://www.loom.com/share/866a490b17d542398a5cb96ea0dae6b2?sid=dc14bfb8-e4ba-42e7-890b-84af76af3df1",
    tab: "Devis",
    duration: "2:09",
  },
  {
    title: "Créer un évènement",
    subtitle: "Tutoriel vidéo sur créer un évènement",
    url: "https://www.loom.com/share/ef4327bde8fc48eaae236911e94d7597?sid=a8a87e7a-2dbf-4b5e-9c47-ad4f441766fb",
    tab: "Planning",
    duration: "2:08",
  },
  {
    title: "Créer une revisite",
    subtitle: "Création de revisite, lien avec le dossier",
    url: "https://www.loom.com/share/1ff2abdaa17f4a9ca4c552a81ca60373?sid=0ab26bc0-bbfc-4137-85bb-e58029a3a009",
    tab: "Planning",
    duration: "1:11",
  },

  {
    title: "Créer un modèle de contrôle",
    subtitle: "Tutoriel vidéo sur créer un modèle de contrôle",
    url: "https://www.loom.com/share/ac3244745519424c9125a15236bbf907?sid=6c6ab1fa-4523-426b-be8a-d3042df084e5",
    tab: "Application mobile",
    duration: "2:19",
  },
  {
    title: "Accéder au Planning",
    subtitle: "Tutoriel vidéo sur accéder au Planning",
    url: "https://www.loom.com/share/6d352b45cc074b30aead488557f21685?sid=163ec4b5-2a51-4e3c-806a-23156068e996",
    tab: "Application mobile",
    duration: "2:43",
  },
  {
    title: "Créer un contrôle",
    subtitle: "Tutoriel vidéo sur créer un contrôle",
    url: "https://www.loom.com/share/acd0ef4dbc98445583eae4cb7e57ec55?sid=7e6d7d38-9dc2-46a3-94b8-c1091167f76a",
    tab: "Application mobile",
    duration: "2:34",
  },
  {
    title: "Ajouter une tâche",
    subtitle: "Tutoriel vidéo sur ajouter une tâche",
    url: "https://www.loom.com/share/29c6443fa1db40329f551149a968ebae?sid=d6bed3de-49e9-450b-9734-02262ac14ecb",
    tab: "Application mobile",
    duration: "2:58",
  },
  {
    title: "Rt batiment",
    subtitle: "Tutoriel vidéo sur rt batiment",
    url: "https://www.loom.com/share/1e16fb0434d1485396f2d83e5ec27b43?sid=cf31d6a0-0f1b-4df8-8dac-b67a2271e1c0",
    tab: "Intégrations",
    duration: "1:43",
  },
  {
    title: "Google agenda",
    subtitle: "Tutoriel vidéo sur google agenda",
    url: "https://www.loom.com/share/66fcf49999e04611bbf3807b66349fec?sid=72751de3-6556-4b97-92a5-d7e5c5fef5b8",
    tab: "Intégrations",
    duration: "2:15",
  },
  {
    title: "Bridge",
    subtitle: "Tutoriel vidéo sur bridge",
    url: "https://www.loom.com/share/47f197b7adb14bbf81b8c5314cf8f065?sid=5ed1a7ae-6cd6-4c20-a231-5673783935d2",
    tab: "Intégrations",
    duration: "1:11",
  },

  {
    title: "Créer un dossier",
    subtitle: "Créer, modifier, supprimer un dossier",
    url: "https://www.loom.com/share/083d7a775d33470fb08e3fe73f21f0ab?sid=f1c42689-f5ce-47fd-9280-e88e50229053",
    tab: "Dossiers",
    duration: "3:42",
  },
  {
    title: "Inviter un partenaire dans un dossier",
    subtitle: "Inviter, gérer les accès, envoyer un message",
    url: "https://www.loom.com/share/994016acd1354d59bb16bc70db31b377?sid=b7486f9e-d159-492a-ae18-7b3f715f983e",
    tab: "Dossiers",
    duration: "2:29",
  },
  {
    title: "Notifier un partenaire",
    subtitle: "Envoyer un email pour notifier un partenaire",
    url: "https://www.loom.com/share/43e9b08671b34100b6a46ff9e6f67a7a?sid=bfa63c12-19b1-4c5d-bab0-d82e584f4098",
    tab: "Dossiers",
    duration: "1:22",
  },
  {
    title: "Changer la prestation d'un dossier",
    subtitle: "Modifier la prestation d'un dossier",
    url: "https://www.loom.com/share/22ac5c372d9d4130ba2c24d501714a6c?sid=da93e257-0ef6-4745-95af-8f3fa9a4dec4",
    tab: "Dossiers",
    duration: "2:07",
  },
];
